export default __webpack_public_path__ + "static/sampoerna-bg1-b03eb6a35d17faa3b50649c8fb7ab1ac.png";